import styled, { css, keyframes } from "styled-components";
import { makeStyles } from "@material-ui/core";

import TextareaAutosize from "@material-ui/core/TextareaAutosize";

const drawerWidth = 440;

export const useStyles = makeStyles((theme) => ({
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  backdrop: {
    // backdropFilter: "blur(2px)",
    // backgroundColor: "rgba(0,0,0,0.2)",
  },
  exampleContainer: {
    padding: "1rem 0",
  },
  functionRunningContainer: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    padding: "0.5rem 1rem",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
  },
  chatFormContainer: {},
  chatForm: {
    position: "relative",
    width: "100%",
  },
  chatInputContainer: {
    position: "relative",
    width: "100%",
  },
  rightActionContainer: {
    position: "absolute",
    right: "0.75rem",
    bottom: "0.75rem",
    padding: "0.25rem",
  },
  updateActionContainer: {
    paddingTop: "1rem",
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
    justifyContent: "space-between",
  },
  updateAction: {
    display: "flex",
    alignItems: "center",
    gap: "0.5rem",
  },
  chatsContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflowY: "auto",
  },
  chatsInnerContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflowY: "auto",

    "&::-webkit-scrollbar": {
      width: "10px",
    },

    "&::-webkit-scrollbar-track": {
      display: "none",
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "transparent",
      borderRadius: "4px",
    },

    "&:hover": {
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "lightgray",
      },
    },
  },
}));

export const fnChatUseStyles = makeStyles(() => ({
  contentRoot: {
    width: "100%",
    whiteSpace: "pre-wrap",
    fontSize: "14px",
    overflow: "auto",
  },

  content: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    overflowY: "auto",

    "&::-webkit-scrollbar": {
      width: "10px",
    },

    "&::-webkit-scrollbar-track": {
      display: "none",
    },

    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "transparent",
      borderRadius: "4px",
    },

    "&:hover": {
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "lightgray",
      },
    },
  },
  contentLoading: {
    color: "#434343",
    "&:after": {
      fontSize: "16px",
      animation: "$blinkingAnimation 1s steps(2) infinite",
      content: "▋",
      verticalAlign: "baseline",
      marginLeft: "0.25rem",
    },
  },
  "@keyframes blinkingAnimation": {
    "0%": {
      opacity: 0,
    },
  },
}));

export const shimmerStyles = {
  shimmer: {
    background: "#f6f7f8",
    backgroundImage:
      "linear-gradient(to right, #f6f7f8 0%, #edeef1 20%, #f6f7f8 40%, #f6f7f8 100%)",
    backgroundRepeat: "no-repeat",
    backgroundSize: "800px 104px",
    display: "inline-block",
    position: "relative",
    animationDuration: "1s",
    animationFillMode: "forwards",
    animationIterationCount: "infinite",
    animationName: "$placeholderShimmer",
    animationTimingFunction: "linear",
  },
  "@keyframes placeholderShimmer": {
    "0%": {
      backgroundPosition: "-468px 0",
    },

    "100%": {
      backgroundPosition: "468px 0",
    },
  },
};

export const steamKeyframe = keyframes`
0% {
  background-position: 0 0;
}
50% {
  background-position: 400% 0;
}
100% {
  background-position: 0 0;
}
`;

export const gradientBorderMixin = css`
  position: relative;
  background: #fff;
  &::before,
  &::after {
    content: "";
    position: absolute;
    left: -2px;
    top: -2px;
    background: linear-gradient(
      45deg,
      #fb0094,
      #0000ff,
      #00ff00,
      #ffff00,
      #ff0000,
      #fb0094,
      #0000ff,
      #00ff00,
      #ffff00,
      #ff0000
    );
    background-size: 400%;
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    z-index: -1;
    animation: ${steamKeyframe} 20s linear infinite;
  }

  &::after {
    filter: blur(50px);
  }
`;

export const AnimatedBorder = styled.div`
  ${gradientBorderMixin}
`;

const dotsKeyframe = keyframes`
  0%,
  20% {
    color: #0000;
    text-shadow: 0.25em 0 0 #0000, 0.5em 0 0 #0000;
  }

  40% {
    color: black;
    text-shadow: 0.25em 0 0 #0000, 0.5em 0 0 #0000;
  }

  60% {
    text-shadow: 0.25em 0 0 black, 0.5em 0 0 #0000;
  }

  80%,
  100% {
    text-shadow: 0.25em 0 0 black, 0.5em 0 0 black;
  }

  80%,
  100% {
    text-shadow: 0.25em 0 0 black, 0.5em 0 0 black;
  }
`;

const rotateKeyframe = keyframes`
from {
  transform: rotate(0deg);
}
to {
  transform: rotate(360deg);
}`;

const fadeInUpKeyframes = keyframes`
0% {
  transform: translateY(100%);
  opacity: 0;
}
100% {
  transform: translateY(0%);
  opacity: 1;
}`;

const opacityKeyframes = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }`;

export const blinking = keyframes`
0% {
  opacity: 0;
}
`;

export const FadeInUp = styled.div`
  animation: ${(props) => props.duration || "0.5s"} ${fadeInUpKeyframes};
`;

export const OpacityAnimation = styled.div`
  animation: ${opacityKeyframes} 1s infinite;
`;

export const LoadingDots = styled.div`
  && {
    &::after {
      content: " .";
      font-size: 25px;
      animation: ${dotsKeyframe} 1s steps(5, end) infinite;
    }
  }
`;

export const Rotate = styled.div`
  && {
    animation: ${rotateKeyframe} 2s linear infinite;
  }
`;

export const ChatUpdateInput = styled(TextareaAutosize)`
  && {
    width: 100%;
    font-size: 14px !important;
    border: 0px solid transparent;
    padding: 0;
    outline: none;
    resize: none;
    text-align: left;

    &::-webkit-scrollbar {
      width: 8px;
      cursor: pointer;
    }

    &::-webkit-scrollbar-thumb {
      background-color: lightgray;
      border-radius: 4px;
      cursor: pointer;
    }

    &:disabled {
      color: gray;
    }
  }
`;

export const ChatsContainer = styled.div`
  & {
    display: flex;
    flex-direction: column;
  }
`;
